import { LOCAL } from "@/store/mutations";

const { ACTIVATE_MODAL_WINDOW, DEACTIVATE_MODAL_WINDOW } = LOCAL;

export default {
	namespaced: true,
	state: {
		active: false,
		component: "",
		class: "",
		data: {},
		key: null,
	},
	getters: {
		isActiveKey: (state) => (key) => key === state.key,
	},
	actions: {
		activate({ commit }, content) {
			commit(ACTIVATE_MODAL_WINDOW, content);
		},
		deactivate({ commit }) {
			commit(DEACTIVATE_MODAL_WINDOW);
		},
		toggle({ commit, state }) {
			const TOGGLE_MUTATION = !state.active ? ACTIVATE_MODAL_WINDOW : DEACTIVATE_MODAL_WINDOW;
			commit(TOGGLE_MUTATION);
		},
	},
	mutations: {
		[ACTIVATE_MODAL_WINDOW](state, content) {
			state.active = true;
			state.component = content.component;
			state.class = content.class;
			state.data = content.data;
		},
		[DEACTIVATE_MODAL_WINDOW](state) {
			state.active = false;
			state.component = "";
			state.class = "";
			state.data = {};
		},
	},
};
